const monthPickerBtn = document.querySelector('#timePickerBtn')
const dateChanger = document.querySelector('#timePicker')
const monthPicker = document.querySelector('.monthPicker')
const year = document.querySelector('.dateChanger_year')
const next = document.querySelector('#next')
const prev = document.querySelector('#prev')

monthPickerBtn.addEventListener('click', () => {
  dateChanger.classList.toggle('u-showMonthPicker')
})

next.addEventListener('click', function (e) {
  let yearNumber = +year.textContent
  yearNumber++
  year.textContent = yearNumber
})
prev.addEventListener('click', function (e) {
  let yearNumber = +year.textContent
  yearNumber--
  year.textContent = yearNumber
})

monthPicker.addEventListener('click', function (e) {
  if (e.target.classList.contains('pickMonth')) {
    const url = location.href
    let newUrl = new URL(url)
    const value = e.target.getAttribute('value')
    let newMonth = `${year.textContent.trim()}-${value.padStart(2, 0)}-01`
    newUrl.searchParams.set('month', newMonth)
    location.href = newUrl.toString()
  }
})

